/** Formats a year, negative = BC, per spec §7.4 ("490 v. Chr." / "490 BC"). */
export function formatYear(year, lang) {
    if (year < 0) {
        const abs = Math.abs(year);
        return lang === "de" ? `${abs} v. Chr.` : `${abs} BC`;
    }
    return `${year}`;
}
//# sourceMappingURL=year.js.map